import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { config1 } from "../../config";
import { Row, Col, Button, Container } from "reactstrap";
import backgroundLogo from "../Background/final-logo.svg";
import { fetchVendorInformation } from "../../Services/allServices";
import "./MyPage.css";

class Processing extends Component {
  state = {
    firstName: "",
    lastName: "",
    isVendorFormCompleted: "",
  };

  componentDidMount = async () => {
    const vendorInformation = await fetchVendorInformation();
    console.log("@@", vendorInformation);
    if (
      vendorInformation.data.personalInformation.personalDetailsComplete &&
      vendorInformation.data.businessDetails.businessDetailsComplete &&
      vendorInformation.data.educationalDetails.educationDetailsComplete &&
      vendorInformation.data.serviceDetails.vendorServiceAndModeDetailsCompleted
    ) {
      this.setState({
        firstName: vendorInformation.data.personalInformation.firstName,
        lastName: vendorInformation.data.personalInformation.lastName,
        isVendorFormCompleted: true,
      });
    } else {
      this.setState({ isVendorFormCompleted: false });
    }
  };

  render() {
    const host = config1.API_HOST;
    const { firstName, lastName, isVendorFormCompleted } = this.state;
    if (isVendorFormCompleted === false) {
      return <Redirect to="/registration" />;
    }
    return (
      <div
        className="app flex-row align-items-center main-container"
        // style={{ background: "#F1F5FF" }}
      >
        {/* <ToastContainer position="bottom-center" autoClose={2000} /> */}
        <Container>
          <Row className="mb-2" style={{ width: "160px", margin: "auto" }}>
            <img src={backgroundLogo} />
          </Row>

          <Row className="justify-content-center">
            <Col md="10">
              <div className="cardHeight">
                <Row className="m-2 m-lg-0">
                  <Col
                    md="6"
                    className="pt-5 marginSpacing d-none d-md-block"
                    style={{ background: "#094184", height: "550px" }}
                  >
                    <div className="mainTitleRegister">
                      <p className="mainTitle paragraph-style">
                        Extend Quality Care On Your Schedule With Momkidcare
                      </p>
                    </div>
                    <div
                      className="mt-4"
                      style={{ display: "flex", margin: "0px 16px" }}
                    >
                      <div
                        style={{
                          // border: "1px solid black",
                          // height: "140px",
                          width: "16px",
                          marginTop: "3px",
                          // textAlign:"center",
                          // margin:"auto"
                        }}
                      >
                        <div
                          style={{
                            background: "white",
                            borderRadius: "50px",
                            height: "11px",
                            width: "11px",
                          }}
                        ></div>
                        <div
                          style={{
                            background: "white",
                            height: "6px",
                            width: "1px",
                            margin: "2px 5px auto",
                          }}
                        ></div>
                        <div
                          style={{
                            background: "white",
                            height: "6px",
                            width: "1px",
                            margin: "2px 5px auto",
                          }}
                        ></div>
                        <div
                          style={{
                            background: "white",
                            height: "6px",
                            width: "1px",
                            margin: "2px 5px auto",
                          }}
                        ></div>

                        <div
                          style={{
                            background: "white",
                            borderRadius: "50px",
                            height: "11px",
                            width: "11px",
                          }}
                        ></div>
                        <div
                          style={{
                            background: "white",
                            height: "6px",
                            width: "1px",
                            margin: "2px 5px auto",
                          }}
                        ></div>
                        <div
                          style={{
                            background: "white",
                            height: "6px",
                            width: "1px",
                            margin: "2px 5px auto",
                          }}
                        ></div>
                        <div
                          style={{
                            background: "white",
                            height: "6px",
                            width: "1px",
                            margin: "2px 5px auto",
                          }}
                        ></div>
                        <div
                          style={{
                            background: "white",
                            borderRadius: "50px",
                            height: "11px",
                            width: "11px",
                          }}
                        ></div>
                        <div
                          style={{
                            background: "white",
                            height: "6px",
                            width: "1px",
                            margin: "2px 5px auto",
                          }}
                        ></div>
                        <div
                          style={{
                            background: "white",
                            height: "6px",
                            width: "1px",
                            margin: "2px 5px auto",
                          }}
                        ></div>
                        <div
                          style={{
                            background: "white",
                            height: "6px",
                            width: "1px",
                            margin: "2px 5px auto",
                          }}
                        ></div>

                        <div
                          style={{
                            background: "white",
                            borderRadius: "50px",
                            height: "11px",
                            width: "11px",
                          }}
                        ></div>
                      </div>
                      <div
                        style={{
                          // border: "1px solid black",
                          // height: "140px",
                          width: "180px",
                          margin: "0px 7px",
                        }}
                      >
                        <div
                          style={{
                            fontSize: "12px",
                            color: "white",
                            fontFamily: "Montserrat",
                          }}
                        >
                          Refined Enquires
                        </div>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "white",
                            margin: "17px auto",
                            fontFamily: "Montserrat",
                          }}
                        >
                          Additional Revenue Stream
                        </div>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "white",
                            margin: "17px auto",
                            fontFamily: "Montserrat",
                          }}
                        >
                          No geographical Boundaries
                        </div>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "white",
                            fontFamily: "Montserrat",
                            // marginTop: "31px",
                          }}
                        >
                          Promotional Partner
                        </div>
                      </div>
                    </div>

                    <div className="imageFixed">
                      <img
                        src="/assets/img/imgMain.png"
                        className="img-fluid img-style"
                        alt="img"
                      />
                    </div>
                  </Col>

                  <Col
                    md="6"
                    className="secondDiv"
                    style={{
                      height: "550px",
                      background: "#fff",
                      overflow: "auto",
                    }}
                  >
                    <div className="mt-5">
                      <img src="/assets/img/success.png" alt='success' className="img-style" />
                    </div>
                    <div>
                      <div className="d-flex justify-content-center">
                        <span className="finalName">
                          Mr./Ms./Mrs. {`${firstName} ${lastName}`}
                        </span>
                      </div>
                      <div className="finalNameDiv">
                        <span className="final">
                          Your application is in review with us, We will get
                          back to soon. Or you can call our
                          <span className="fontHeavy mx-1">
                            BD Executive- Ms Niharika
                          </span>
                          at <span className="fontHeavy">9717723995</span>.
                        </span>
                      </div>
                    </div>
                    <div className="back2home">
                      <span
                        className="back2homeText"
                        onClick={() =>
                          window.location.replace("https://www.momkidcare.com/")
                        }
                      >
                        Back To Home
                      </span>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
export default Processing;
